// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 597) return "static/chunks/597-36c3532e9d9024b8.js";
	if (chunkId === 61) return "static/chunks/61-10094abe8b4d5ef4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"2333cdf8e7784eec","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"b2511932946ba6fb","367":"26d47001f690392e","639":"cf9d73bb0d566e4a","748":"678bb3fcb399b4ab"}[chunkId] + ".js";
};